import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import OButton from "components/reusable/OButton";
import ErrorMessage from "components/ErrorMessage";
import { apiPost, apiGet } from "utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";

const EditPriceModal = ({ isOpen, onClose, price, onSuccess }) => {
  const notification = useToastContext();
  const [products, setProducts] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [areas, setAreas] = useState([]);
  const { register, handleSubmit, reset, watch, formState: { errors } } = useForm();

  useEffect(() => {
    if (isOpen) {
      apiGet(apiPath.ListProduct).then(res => setProducts(res?.data?.results?.docs || []));
      apiGet(apiPath.districtList).then(res => setDistricts(res?.data?.results?.docs || []));
    }
  }, [isOpen]);

  useEffect(() => {
    if (watch("district")) {
      apiGet(`${apiPath.areaList}?district=${watch("district")}`).then(res => setAreas(res?.data?.results?.docs || []));
    }
  }, [watch("district")]);

  useEffect(() => {
    if (price) {
      reset({
        products: price.products || "",
        retail_spot_price: price.retail_spot_price || "",
        whoelsale_spot_price: price.whoelsale_spot_price || "",
        type: price.type || "",
        district: price.district || "",
        area: price.area || "",
      });
    }
  }, [price, reset]);

  const onSubmit = async (data) => {
    const result = await apiPost(apiPath.editPrice, { ...data, _id: price._id });
    if (result?.data?.success) {
      notification.success(result.data.message);
      onClose();
      onSuccess && onSuccess();
    } else {
      notification.error(result.data.message);
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Edit Price"
      className="fixed inset-0 flex items-center justify-center z-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
        <h2 className="font-medium text-black mb-3 text-xl">Edit Price</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <select {...register("products", { required: "Product is required" })} className="w-full border p-2 rounded">
              <option value="">Select Product</option>
              {products.map(p => <option key={p._id} value={p._id}>{p.product_name}</option>)}
            </select>
            <ErrorMessage message={errors?.products?.message} />
          </div>
          <div className="mb-4">
            <input type="number" placeholder="Retail Spot Price" {...register("retail_spot_price")} className="w-full border p-2 rounded" />
          </div>
          <div className="mb-4">
            <input type="number" placeholder="Wholesale Spot Price" {...register("whoelsale_spot_price")} className="w-full border p-2 rounded" />
          </div>
          <div className="mb-4">
            <select {...register("type", { required: "Type is required" })} className="w-full border p-2 rounded">
              <option value="">Select Type</option>
              <option value="retail">Retail</option>
              <option value="wholesale">Wholesale</option>
            </select>
            <ErrorMessage message={errors?.type?.message} />
          </div>
          <div className="mb-4">
            <select {...register("district")} className="w-full border p-2 rounded">
              <option value="">Select District</option>
              {districts.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
            </select>
          </div>
          <div className="mb-4">
            <select {...register("area")} className="w-full border p-2 rounded">
              <option value="">Select Area</option>
              {areas.map(a => <option key={a._id} value={a._id}>{a.name}</option>)}
            </select>
          </div>
          <div className="flex justify-end">
            <OButton label="Save" type="submit" />
            <button type="button" onClick={onClose} className="ml-4 text-black bg-[#E1E1E1] px-4 py-2 rounded">Cancel</button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditPriceModal;